import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'

const endpoints = ((baseURL) => {
  //  LandingPages
  return {
    listLandingpages: (idList, filterParams) =>
      `${baseURL}/api/lists/${idList}/landingpages?${encodeParams(
        filterParams
      )}`,
    createLandingPages: (idMessage) =>
      `${baseURL}/api/LandingPages/email/${encodeURIComponent(idMessage)}`,
    getStyleMode: () => `${baseURL}/api/stylemode`
  }
})(process.env.BEPUBCUSTOM_URL)

/**
 * @typedef  {Object} LandingpageItem
 * @property {number} Id
 * @property {string} Name
 * @property {string} Notes
 * @property {boolean} Status
 * @property {string} CreationDate
 * @property {string} ModifyDate
 *
 *
 * @typedef {Object} LandingpagePagedList
 * @property {Array<LandingpageItem>} Items
 * @property {number} PageNumber
 * @property {number} PageSize
 * @property {number} TotalItems
 *
 */

/**
 * @description return list of landingpages
 * @param {number} idList list id
 * @param {Object} filterParams
 * @param {number} filterParams.pageSize Number of landing returned
 * @param {number} filterParams.pageNumber Page number
 * @param {string} filterParams.orderBy Order by specified field
 * @param {boolean} filterParams.orderDescending Order descending
 * @returns {LandingpagePagedList}
 */
export const bePubCustomListLandingPages = (idList, filterParams) => {
  const url = endpoints.listLandingpages(idList, filterParams)

  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const bePubCustomCreateLandingPages = (idMessage) => {
  const url = endpoints.createLandingPages(idMessage)

  return apiWrapper({
    method: 'post',
    url
  }).then(extractApiData)
}
